<template>
	<section class="search_results no_banner_page clearfix">
		<div class="no_results container" v-show="productsQuery.length == 0">
			<div class="cat_inner row clearfix">
				<div class="main col-lg-10 col-md-12 col-xs-12">
					<div class="cat_title">מוזר, אבל אין לנו תוצאות ל״{{ query }}״</div>
					<div class="text">
						כנראה שאין לנו במלאי, אבל שווה לוודא שהקלדת נכון. בכל מקרה,
						<br />
						ניתן לשלוח לנו את שם המוצר שחיפשת עם הפרטים שלך ואנחנו נשמח לחפש אותו עבורך, אצלנו במדפים או אצל
						הספקים שלנו.
					</div>
					<div class="results_form form_before" v-html="wpData.find_product_form"></div>
					<div class="results_form form_thank" style="display: none">
						היי, קיבלנו. אנחנו בודקים ונעדכן אותך אם בכל זאת הצלחנו למצוא את המוצר עבורך
					</div>
				</div>
			</div>
		</div>
		<div class="has_results container" v-if="productsQuery.length > 0">
			<div class="cat_inner row clearfix">
				<div class="main col-lg-12 col-md-12 col-xs-12">
					<h1 class="cat_title">תוצאות חיפוש</h1>
					<div class="title_s">
						מצאנו {{ productsQuery.length }} תוצאות למילה "{{ query }}" ב-{{ lengthOfCategories }} מחלקות
					</div>

					<div
						class="results_item toggleContainer active"
						v-for="(cat, index) in childCategories"
						:key="index"
					>
						<h2 class="results_top ease">
							<a href="javascript:void(0);" onclick="toggle(this)">
								{{ cat.name }}
								<span>({{ getQuantityByCategory(cat.id) }})</span>
								<arrow-down />
							</a>
						</h2>
						<div class="results_open toggleInner" style="display: block">
							<div class="row">
								<product
									:product="product"
									v-for="product in getProductsByCategory(cat.id)"
									:key="product.id"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import ArrowDown from "../assets/img/arrow_down.svg";
	import Product from "../components/Product/Product";

	export default {
		data() {
			return {
				wpData: wpData,
			};
		},
		watch: {
			$route(to, from) {
				if (to.query.s != from.query.s) {
					var $form = document.querySelector(".form_before");
					var $thank = document.querySelector(".form_thank");
					$thank.setAttribute("style", "display: none");
					$form.setAttribute("style", "display:block");
				}
			},
		},
		mounted: function () {
			setTimeout(() => {
				jQuery(".wpcf7-form").each(function () {
					//console.log(this);
					//console.log(wpcf7);
					// wpcf7.initForm($(this))
				});
				$(".submit_bt").on("click", function (e) {
					$(".submit_bt").addClass("proccessing");
				});
				$(".wpcf7").on("wpcf7invalid", function (e) {
					$(".submit_bt").removeClass("proccessing");
				});
				$(".wpcf7").on("wpcf7submit", function (e) {
					if ($(".ajax-loader").hasClass("is-active")) {
						e.preventDefault();
						return false;
					}
					$(".submit_bt").removeClass("proccessing");
				});
				document.addEventListener("wpcf7mailsent", function (event) {
					if (event.detail.apiResponse.status == "mail_sent") {
						var $form = document.querySelector(".form_before");
						var $thank = document.querySelector(".form_thank");
						$form.setAttribute("style", "display: none");
						$thank.setAttribute("style", "display:block");
					}
				});
			}, 1000);
		},

		methods: {
			getCategory(id) {
				return this.$store.state.categories.find((cat) => cat.id == id);
			},
			getCatName(id) {
				let cat = this.getCategory(id);
				return cat.name;
			},
			mailSent() {
				this.mailOk = true;
			},
			getQuantityByCategory(id) {
				let q = 0;
				this.productsQuery.map((p) => {
					if (p.categories.includes(id)) {
						q++;
					}
				});
				return q;
			},
			getProductsByCategory(id) {
				return this.productsQuery.filter((p) => p.categories.includes(id));
			},
		},
		computed: {
			productsQuery() {
				return this.$store.state.searchResultProducts.length
					? this.$store.state.searchResultProducts
					: this.$store.state.products;
			},
			childCategories() {
				let cats = [];
				const keys = this.categories;
				var parent_position = 0;

        console.log(keys);

				keys.map((key) => {
					let cat = this.getCategory(key);
					if (typeof cat != "undefined" && typeof cat.parent != "undefined" && cat.parent === 0) {
						parent_position = cat.position;
					}
					if (cat && typeof cat != "undefind" && cat.parent != 0) {
						var child = cat;
						if (child.position === 0) {
							child.position = parent_position;
						}
						cats.push(child);
					}
				});
				console.log(cats);
				//cats.sort((a, b) => a.position - b.position);
				cats.sort((a, b) => this.getQuantityByCategory(a.position) - this.getQuantityByCategory(b.position));

				//console.log(cats);

				return cats;
			},
			categories() {
				let categories = [];
				this.productsQuery.map(function (product) {
					categories = categories.concat(product.categories);
				});
				let a = categories.filter((v, i) => categories.indexOf(v) == i);
				return a;
			},
			lengthOfCategories() {
				return this.childCategories.length;
			},
			query() {
				return this.$store.state.search ? this.$store.state.search : this.$route.query.s;
			},
		},
		components: {
			ArrowDown,
			Product,
		},
	};
</script>
